import {
  FETCH_PRODUCT_LIST,
  LoadProductsFromCategoryResponseAction,
  ProductSequenceData,
  UPDATE_PRODUCT_LIST_IN_STATE,
  updateProductListInStateAction,
  UPDATE_PRODUCT_LIST_SEQUENCE_MODE,
  updateProductListSequenceModeAction,
  RESET_PRODUCT_LIST,
  RESET_PRODUCT_SEQUENCE,
  UPDATE_NUMBER_OF_PINNED_PRODUCTS,
  UpdateNumberOfPinnedProductsAction,
  UPDATE_PINNED_PRODUCTS,
  SET_PINNED_PRODUCTS_MODE,
  SetPinnedProductsModeAction,
  SET_SORTING_RULE,
  SetSortingRuleAction,
  BusinessRulesListDetails,
  FETCH_SORTING_LIST,
  LoadSortingRulesListResponseAction,
  FETCH_SORTED_PRODUCTS,
  FETCH_PRODUCT_IDS,
  ASYNC_SORT_PROGRESS,
  UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC,
  UPDATE_PRODUCT_SEQUENCE_LIST_SYNC,
  GET_PRODUCT_SEQUENCE_LIST,
  FETCH_PRODUCT,
  UPDATE_PRODUCT_SEQUENCE,
  WatchedProductListData,
  FETCH_WATCHED_PRODUCT_LIST,
  WatchedProductListResponse,
  ADD_PRODUCT_TO_WATCH_LIST,
  REMOVE_PRODUCT_FROM_WATCH_LIST,
  addRemoveProductInWatchListPayload,
  REVERT_PRODUCT_SEQUENCE,
  ProductIdsData,
  ProductListSequenceResponse,
  RESET_SEQUENCE_REQUESTED_BY_BOOST_BURY,
  FETCH_LOCKS_FOR_CATEGORY,
  LocksInCategory,
  LocksInCategoryResponse,
  LOCK_PRODUCT_COMPLETED,
  UNLOCK_PRODUCT_COMPLETED,
  UnLockProductResponsePayload,
  RESET_LOCKS_IN_CATEGORY,
  lockUnLockProductPayload,
  RESET_SAVED_LOCKED_UNLOCKED_PRODUCTS,
  SET_LOCKED_UNLOCKED_PRODUCTS,
  GET_CONTENT_SLOTS,
  ContentSlot,
  ContentSlotsResponse,
  RESET_CONTENT_SLOTS,
  updateContentSlotStateResponse,
  UPDATE_CONTENT_SLOT_STATE,
  DELETE_CONTENT_SLOT_COMPLETED,
  deleteContentSlotPayload,
  SET_PINNED_UNPINNED_PRODUCTS,
  BULK_SET_PINNED_UNPINNED_PRODUCTS,
  bulkPinnedUnPinnedProductsPayload,
  RESET_STORED_PINNED_UNPINNED_PRODUCT_IDS,
  RESET_PINNED_UNPINNED_PRODUCTS,
  SET_PINNED_PRODUCTS,
  GET_PINNED_PRODUCTS,
  getPinnedProductsResponse,
  RESET_CONTENT_SLOT_LOADING,
  SET_CONTENT_SLOT_LOADING,
  SET_SELECTED_ITEMS,
  LOAD_INITIAL_PRODUCTS_DETAILS,
  ProductsData,
  SET_CURRENT_PAGE,
  SET_PENDING_SCROLL_TARGET,
  CLEAR_PENDING_SCROLL_TARGET,
  UPDATE_PROGRESS_CACHE,
  RESET_PROGRESS_CACHE,
  ASSIGN_PRODUCT_POSITION,
  RESET_POSITIONED_PRODUCT_IDS,
  UPDATE_PRODUCT_POSITION,
  REMOVE_PRODUCT_POSITION,
  SET_PREVIEW_OPTIONS,
  SetPreviewOptionsAction,
  SetPreviewModeAction,
  SET_PREVIEW_MODE,
  RESET_PREVIEW,
  LOAD_REMAINING_PRODUCTS,
  SET_REMAINING_PRODUCTS_MODAL,
  SetRemainingProductsModalAction,
  SET_IS_NEW_CATEGORY,
  WEBSOCKET_CATEGORY_SAVE_STARTED,
  WEBSOCKET_CATEGORY_SAVE_COMPLETED,
  WEBSOCKET_CATEGORY_SAVE_FAILED,
  WebSocketCategorySaveStartedAction,
  WebSocketCategorySaveCompletedAction,
  WebSocketCategorySaveFailedAction,
  UpdateProductSequencePayload,
  FetchInProgressRequestsSnapshotSuccessAction,
  FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT,
  CLEAR_PENDING_SAVE_REQUEST_ID,
  ClearPendingSaveRequestIdAction,
} from "./ProductListTypes";
import { SEQUENCE_MODE_TYPE } from "../../utils/Constants";
import {
  ADD_PRODUCT_IN_CATEGORY,
  LoadSortedProductsAction,
  REMOVE_PRODUCT_IN_CATEGORY,
  SortedProductScore,
} from "../product/ProductTypes";
import { DELETE_PRODUCT_BY_CATEGORIES } from "../remove-product-categories/RemoveProductCategoriesTypes";
import { ADD_PRODUCTS_TO_CATEGORIES } from "../add-product-categories/AddProductCategoriesTypes";
import {
  updatePositionsToProducts,
  havePinnedProductsChanged,
  handleUndefinedProductsAndLocks,
  updateProductSequencePositions,
} from "utils/ProductUtil";
import { getUserId, getUserName } from "../../services/Auth0UserService";

export interface ProductListState {
  isFetched: boolean;
  isFetching: boolean; // flag to indicate that product list is loading (or refreshing) to be used to show the loading progress/spinner
  isSequenceUpdated: boolean;
  isSequenceLoading: boolean;
  isSequenceSaving: boolean; // true if there is an inflight request to save the sequence, to be used to show a spinner
  savingCategoryIds: string[];
  currentUserInitiatedSaves: string[]; // Track categoryIds initiated by current user (for snackbar)
  isSquenceUpdateRequest: boolean;
  productSequences: ProductSequenceData[]; // why do we need this, when we have ProductReducer to store products?
  editSequenceList: ProductSequenceData[]; // why do we need this, when we have ProductReducer to store products?
  sequenceMode: number;
  pinnedProducts: PinnedProducts;
  isPinnedProductsMode: boolean;
  sortingRule: string | null;
  sortingRulesList: BusinessRulesListDetails[];
  isSortingRulesListLoaded: boolean;
  isProductIdsFetched: boolean;
  isFetchingProductIds: boolean;
  productIds: string[]; // the saved product sequence (should probably rename to savedSequence)
  categoryId?: string;
  isRefreshingAllProducts?: boolean;
  isFetchingSortedProducts: boolean;
  requestId: string | null;
  addingRemovingProductIdsList?: string[];
  isUpdateFunctionInvoked?: boolean;
  updatedStateProductIds: string[]; // the working (i.e. unsaved) product sequence (should probably rename to workingSequence)
  isProductAddedToCategoryFromClipBoard?: boolean;
  isUpdateProductSequenceError?: boolean;
  watchedProductList: WatchedProductListData[];
  originalEditSequenceList: ProductSequenceData[];
  originalProductSequences: ProductSequenceData[];
  originalUpdatedStateProductIds: string[];
  productIdsData: ProductIdsData;
  total?: number;
  productSequenceList: ProductListSequenceResponse;
  isBoostBurySequenceRequested: boolean;
  locksInCategory: LocksInCategory[];
  savedLockedProductsInCategory: lockUnLockProductPayload[];
  savedUnlockedProductsInCategory: lockUnLockProductPayload[];
  locksRemoveInCategory: LocksInCategory[];
  contentSlots: ContentSlot[];
  pinnedProductIds: string[];
  storedPinnedProductIds: string[];
  storedUnpinnedProductIds: string[];
  originalStoredPinnedProductIds: string[];
  isContentSlotLoading: boolean;
  selectedItems: ProductSequenceData[];
  currentPage: number;
  progressCache: Record<string, number>;
  isFetchingCategoryProductIds: boolean;
  isProductSequenceUpdated: boolean;
  updatedPositionedProductIds: string[];
  originalPositionedProductIds: string[];
  previewOptions: {
    date: string | null;
    stock: boolean;
    published: boolean;
  };
  isPreviewMode: boolean;
  remainingProductsModal: {
    isOpen: boolean;
    progress: number;
    total: number;
    loaded: number;
    isCancelled: boolean;
  };
  isNewCategory: boolean;
  pendingCategorySaveRequestIds?: Record<string, { categoryId: string; payload?: UpdateProductSequencePayload }>; // Map of requestId -> {categoryId, payload} for saves we initiated
  pendingScrollTarget: { productId: string; nonce: number } | null;
}

const initialState: ProductListState = {
  isFetched: false,
  isFetching: false,
  isSequenceUpdated: false,
  isSequenceLoading: false,
  isSequenceSaving: false,
  savingCategoryIds: [],
  currentUserInitiatedSaves: [],
  isSquenceUpdateRequest: false,
  productSequences: [],
  editSequenceList: [],
  sequenceMode: SEQUENCE_MODE_TYPE.VIEW,
  isPinnedProductsMode: false,
  pinnedProducts: {
    numberOfPinnedProducts: 0,
    pinnedProductIds: [],
  },
  sortingRule: null,
  sortingRulesList: [],
  isSortingRulesListLoaded: false,
  isProductIdsFetched: false,
  isFetchingProductIds: false,
  productIds: [],
  categoryId: "",
  isRefreshingAllProducts: false,
  isFetchingSortedProducts: false,
  requestId: null,
  addingRemovingProductIdsList: [],
  isUpdateFunctionInvoked: false,
  updatedStateProductIds: [],
  isProductAddedToCategoryFromClipBoard: false,
  isUpdateProductSequenceError: false,
  watchedProductList: [],
  originalEditSequenceList: [],
  originalProductSequences: [],
  originalUpdatedStateProductIds: [],
  productIdsData: {
    productIds: [],
    categoryId: "",
    next: "",
    count: 0,
    total: 0,
  },
  productSequenceList: {
    accountId: "",
    requestId: "",
    response: {
      statusCode: 0,
      body: "",
    },
  },
  isBoostBurySequenceRequested: false,
  locksInCategory: [],
  savedLockedProductsInCategory: [],
  savedUnlockedProductsInCategory: [],
  locksRemoveInCategory: [],
  contentSlots: [],
  pinnedProductIds: [],
  storedPinnedProductIds: [],
  storedUnpinnedProductIds: [],
  originalStoredPinnedProductIds: [],
  isContentSlotLoading: false,
  selectedItems: [],
  currentPage: 1,
  pendingScrollTarget: null,
  progressCache: {},
  isFetchingCategoryProductIds: false,
  isProductSequenceUpdated: false,
  updatedPositionedProductIds: [],
  originalPositionedProductIds: [],
  previewOptions: {
    date: null,
    stock: false,
    published: false,
  },
  isPreviewMode: false,
  remainingProductsModal: {
    isOpen: false,
    progress: 0,
    total: 0,
    loaded: 0,
    isCancelled: false,
  },
  isNewCategory: false,
};

function applyPinnedUnpinnedProductsSequenceUpdate(
  state: ProductListState,
  catalogId: string,
  categoryId: string,
  unpinnedProducts: string[],
  updatedPinnedProducts: string[],
  newlyUnpinnedIds: Set<string>,
  productIdsToEnsureInList: string[],
): ProductListState {
  const pinnedProductsFromDB = [...state.pinnedProductIds];

  const lockedPositions = new Set();
  const productList = new Array(state.productSequences.length);
  let counter = 0;

  const lockedProducts: ProductSequenceData[] = [];
  const pinnedSequenceProducts: ProductSequenceData[] = [];
  const unpinnedSequenceProducts: ProductSequenceData[] = [];
  const remainingProducts: ProductSequenceData[] = [];
  const updatedLocksInCategory = [
    ...state.locksInCategory,
    ...state.savedLockedProductsInCategory,
  ];

  state.productSequences.forEach((product) => {
    const isLocked = updatedLocksInCategory?.some(
      (locked) =>
        locked.productId === product.productId &&
        locked.catalogId === catalogId &&
        locked.categoryId === categoryId,
    );

    if (
      isLocked &&
      !state.savedUnlockedProductsInCategory.some(
        (p) => p.productId === product.productId,
      )
    ) {
      lockedProducts.push(product);
    } else if (updatedPinnedProducts.includes(product.productId)) {
      pinnedSequenceProducts.push(product);
    } else {
      if (
        state.storedUnpinnedProductIds.includes(product.productId) ||
        newlyUnpinnedIds.has(product.productId)
      ) {
        unpinnedSequenceProducts.push(product);
      }
      remainingProducts.push(product);
    }
  });

  const getNextAvailablePosition = () => {
    while (lockedPositions.has(++counter)) {}
    return counter - 1;
  };

  const addProductToList = (
    product: ProductSequenceData,
    position: number,
  ) => {
    productList[position] = {
      ...product,
      sequence: position + 1,
    };
  };

  const isProductInList = (pid: string) => {
    return productList.some((p) => p && p.productId === pid);
  };

  lockedProducts.forEach((product) => {
    if (
      !state.savedUnlockedProductsInCategory.some(
        (p) => p.productId === product.productId,
      )
    ) {
      const originalIndex = state.productSequences.findIndex(
        (p) => p.productId === product.productId,
      );
      lockedPositions.add(originalIndex + 1);
      addProductToList(product, originalIndex);
    }
  });

  pinnedSequenceProducts.forEach((product) => {
    if (!isProductInList(product.productId)) {
      const nextPos = getNextAvailablePosition();
      addProductToList(product, nextPos);
    }
  });

  for (const productId of productIdsToEnsureInList) {
    if (!isProductInList(productId)) {
      const nextPos = getNextAvailablePosition();
      const productPos = state.productSequences.find(
        (p) => p.productId === productId,
      )?.position;
      addProductToList(
        { productId, sequence: nextPos + 1, position: productPos },
        nextPos,
      );
    }
  }

  remainingProducts.forEach((product) => {
    if (!isProductInList(product.productId)) {
      const nextPos = getNextAvailablePosition();
      addProductToList(product, nextPos);
    }
  });

  const updatedProductSequences = productList.filter(Boolean);
  const isNewPinnedProductsExists =
    pinnedSequenceProducts.length > 0 &&
    havePinnedProductsChanged(
      pinnedSequenceProducts,
      pinnedProductsFromDB,
      state.productSequences,
    );
  const isUnpinnedProductsExists =
    unpinnedSequenceProducts.length > 0 &&
    unpinnedSequenceProducts.some((product) =>
      pinnedProductsFromDB.includes(product.productId),
    );
  const isProductSequenceOrderChanged = !updatedProductSequences.every(
    (e, i) => e.productId === state.productIds[i],
  );
  const shouldEnableEditMode =
    isNewPinnedProductsExists ||
    isUnpinnedProductsExists ||
    state.savedLockedProductsInCategory.length > 0 ||
    state.savedUnlockedProductsInCategory.length > 0 ||
    isProductSequenceOrderChanged;

  const updatedPositionedProductIds = [
    ...new Set([
      ...productList
        .filter((p) => p && p.position !== undefined)
        .map((p) => p.productId),
      ...updatedPinnedProducts,
      ...unpinnedProducts,
    ]),
  ];

  return {
    ...state,
    storedPinnedProductIds: updatedPinnedProducts,
    storedUnpinnedProductIds: unpinnedProducts,
    originalStoredPinnedProductIds: updatedPinnedProducts,
    productSequences: updatedProductSequences,
    editSequenceList: updatedProductSequences,
    updatedPositionedProductIds,
    updatedStateProductIds: updatedProductSequences.map(
      (product) => product.productId,
    ),
    sequenceMode: shouldEnableEditMode
      ? SEQUENCE_MODE_TYPE.EDIT
      : SEQUENCE_MODE_TYPE.VIEW,
  };
}

export interface PinnedProducts {
  numberOfPinnedProducts: number;
  pinnedProductIds: string[];
}

export const ProductListReducer = (
  state: ProductListState = initialState,
  action,
): ProductListState => {
  switch (action.type) {
    case FETCH_PRODUCT_LIST.START: {
      return {
        ...state,
        isFetching: true,
        progressCache: {}, // Reset progress cache when starting to fetch new category
      };
    }
    case FETCH_PRODUCT_LIST.STOP: {
      return {
        ...state,
        isFetching: false,
      };
    }
    case FETCH_PRODUCT_LIST.SUCCESS: {
      const fetchAction = action as LoadProductsFromCategoryResponseAction;

      return {
        ...state,
        isFetched: true,
        sequenceMode:
          action.payload.isRefreshingAllProducts === true ||
          state.isProductSequenceUpdated === true ||
          state.sequenceMode === SEQUENCE_MODE_TYPE.EDIT
            ? state.sequenceMode
            : 1,
        categoryId: fetchAction.payload.categoryId,
        isRefreshingAllProducts: false,
      };
    }
    case ASYNC_SORT_PROGRESS.START:
      return {
        ...state,
        isFetchingSortedProducts: true,
      };
    case ASYNC_SORT_PROGRESS.STOP:
      return {
        ...state,
        isFetchingSortedProducts: false,
      };
    case DELETE_PRODUCT_BY_CATEGORIES.DONE: {
      const productIdToBeRemoved = action.payload.productId;
      const productList = [...state.productSequences].filter(
        (prod) => productIdToBeRemoved !== prod.productId,
      );

      const updatedListIds = productList.map((item) => item.productId);
      const updatedProductIdsData = {
        ...state.productIdsData,
        productIds: updatedListIds,
        total: updatedListIds.length,
      };
      return {
        ...state,
        productSequences: productList,
        editSequenceList: productList,
        productIds: updatedListIds,
        originalEditSequenceList: productList,
        originalProductSequences: productList,
        productIdsData: updatedProductIdsData,
        updatedPositionedProductIds: state.updatedPositionedProductIds?.filter(
          (id) => id !== productIdToBeRemoved,
        ),
        originalPositionedProductIds:
          state.originalPositionedProductIds?.filter(
            (id) => id !== productIdToBeRemoved,
          ),
      };
    }
    case FETCH_SORTED_PRODUCTS.SUCCESS: {
      const fetchedProductActionObj = action as LoadSortedProductsAction;
      const productsArray = fetchedProductActionObj.payload.response?.body?.products;
      if (!productsArray || productsArray.length === 0) {
        return state;
      }
      //calculate product scores
      const calculateProductScores = (products: SortedProductScore[]) => {
        const scores = {};
        products.forEach((p) => {
          const scoreSum = Array.isArray(p.score)
            ? p.score.some((score) => score < 0)
              ? p.score.find((score) => score < 0)
              : p.score.reduce((sum, a) => sum + a, 0)
            : p.score;
          scores[p.productId] = scoreSum;
        });
        return scores;
      };

      // get scores for products other than the negative score if we had any
      const getOtherScoresSum = (product: any) => {
        const scores = Array.isArray(product?.score)
          ? product?.score.filter((score) => score >= 0)
          : product?.score;

        return Array.isArray(scores)
          ? scores.reduce((sum, score) => sum + score, 0)
          : scores;
      };

      // Sorting function for products. Negative-score branch resolves via a
      // pre-built productById map to keep the comparator at O(1) per call.
      const sortProductsByScore = (
        a: ProductSequenceData,
        b: ProductSequenceData,
        productsWithScore: any,
        productById: Map<string, SortedProductScore>,
      ) => {
        const scoreA = productsWithScore[a.productId];
        const scoreB = productsWithScore[b.productId];

        // If both scores are negative, sort by other scores
        if (scoreA < 0 && scoreB < 0) {
          const productA = productById.get(a.productId);
          const productB = productById.get(b.productId);

          const sumA = getOtherScoresSum(productA);
          const sumB = getOtherScoresSum(productB);

          return sumB - sumA;
        }

        // If only one score is negative, it should go last
        if (scoreA < 0) return 1;
        if (scoreB < 0) return -1;

        // Normal sorting for non-negative scores
        return scoreB - scoreA;
      };

      const productsWithScore = calculateProductScores(productsArray);
      const productSeqCopy = [...state.productSequences];
      // Lookups built once: O(1) replacements for the comparator's
      // productsArray.find (B1) and the lock placement productSeqCopy.find (B3).
      const productById = new Map(
        productsArray.map((p: SortedProductScore) => [p.productId, p]),
      );
      const productSeqById = new Map(
        productSeqCopy.map((p) => [p.productId, p]),
      );

      // Check if there are any locks for the current category
      const locksForCurrentCategory = state.locksInCategory.filter(
        (lock) => lock.categoryId === state.categoryId,
      );
      const pinnedProducts = state.pinnedProductIds;

      // If there are no locks and pins, sort all products
      if (locksForCurrentCategory.length === 0 && pinnedProducts.length === 0) {
        const sortedProducts = productSeqCopy.sort((a, b) =>
          sortProductsByScore(a, b, productsWithScore, productById),
        );

        const productIdsData = sortedProducts.map(
          (product) => product.productId,
        );
        const sequencedData = sortedProducts.map((item, index) => ({
          ...item,
          sequence: index + 1,
        }));

        const isProductsSequenceOrderChanged = sequencedData.some(
          (item, index) =>
            item.productId !== state.productSequences[index]?.productId,
        );

        return {
          ...state,
          productSequences: sequencedData,
          editSequenceList: sequencedData,
          sequenceMode: isProductsSequenceOrderChanged ? 2 : 1,
          updatedStateProductIds: productIdsData,
          isProductSequenceUpdated: true,
        };
      }

      // Create a map of locked positions
      const lockedPositions = new Map(
        locksForCurrentCategory.map((lock) => [
          lock.position - 1,
          lock.productId,
        ]),
      );

      // Create a set of pinned product IDs for faster lookup
      const pinnedProductsSet = new Set(pinnedProducts);

      // Find the last pinned product position
      const lastPinnedPosition = productSeqCopy.reduce(
        (lastPosition, product, index) => {
          if (
            pinnedProductsSet.has(product.productId) &&
            !lockedPositions.has(index)
          ) {
            return index;
          }
          return lastPosition;
        },
        -1,
      );

      // O(1) probe vs `Array.from(lockedPositions.values()).includes(...)`.
      const lockedProductIdsSet = new Set(lockedPositions.values());
      const regularProducts = productSeqCopy.filter(
        (product) =>
          !lockedProductIdsSet.has(product.productId) &&
          !pinnedProductsSet.has(product.productId),
      );

      const sortedRegularProducts = regularProducts.sort((a, b) =>
        sortProductsByScore(a, b, productsWithScore, productById),
      );

      const finalSortedProducts: ProductSequenceData[] = new Array(
        productSeqCopy.length,
      );

      // First, place locked products in their positions
      lockedPositions.forEach((productId, position) => {
        const lockedProduct = productSeqById.get(productId);
        if (lockedProduct) {
          finalSortedProducts[position] = lockedProduct;
        }
      });

      // Place pinned products in their original positions if not locked
      productSeqCopy.forEach((product, index) => {
        if (
          pinnedProductsSet.has(product.productId) &&
          !lockedPositions.has(index) &&
          index <= lastPinnedPosition
        ) {
          finalSortedProducts[index] = product;
        }
      });

      // Finally, fill remaining positions with sorted regular products
      let regularProductIndex = 0;
      for (let i = 0; i < finalSortedProducts.length; i++) {
        if (
          !finalSortedProducts[i] &&
          regularProductIndex < sortedRegularProducts.length
        ) {
          finalSortedProducts[i] = sortedRegularProducts[regularProductIndex++];
        }
      }

      // Clean up any undefined entries and create sequence data
      const updatedSortedProducts = finalSortedProducts.filter(Boolean);
      const productIdsData = updatedSortedProducts.map(
        (product) => product.productId,
      );
      const sequencedData = updatedSortedProducts.map((item, index) => ({
        ...item,
        sequence: index + 1,
      }));

      const isProductsSequenceOrderChanged = sequencedData.some(
        (item, index) =>
          item.productId !== state.productSequences[index]?.productId,
      );

      return {
        ...state,
        productSequences: sequencedData,
        editSequenceList: sequencedData,
        sequenceMode: isProductsSequenceOrderChanged ? 2 : 1,
        updatedStateProductIds: productIdsData,
        storedPinnedProductIds: state.pinnedProductIds,
        isProductSequenceUpdated: true,
      };
    }
    case FETCH_SORTED_PRODUCTS.FAILURE: {
      return {
        ...state,
        isFetchingSortedProducts: false,
      };
    }
    case FETCH_PRODUCT_LIST.REQUEST: {
      const payload = action?.payload;
      return {
        ...state,
        isFetched: false,
        isRefreshingAllProducts: payload?.isRefreshingAllProducts
          ? true
          : false,
      };
    }
    case FETCH_PRODUCT_LIST.FAILURE: {
      return {
        ...state,
        isFetched: true,
        isRefreshingAllProducts: false,
      };
    }
    case UPDATE_PRODUCT_LIST_IN_STATE: // updates the working sequence after a drag and drop, or sort
      let updateAction = action as updateProductListInStateAction;
      const sortedProducts = updateAction.payload.products.map((prod, idx) => ({
        ...prod,
        sequence: idx + 1,
      }));
      const seqProductIds = updateAction.payload.products.map(
        (product) => product.productId,
      );
      return {
        ...state,
        editSequenceList: sortedProducts,
        productSequences: updateAction.payload.isSaveAction
          ? sortedProducts
          : state.productSequences,
        updatedStateProductIds: seqProductIds,
        isProductSequenceUpdated: true,
        updatedPositionedProductIds: sortedProducts
          .filter((product) => product.position !== undefined)
          .map((product) => product.productId),
      };
    case UPDATE_PRODUCT_LIST_SEQUENCE_MODE:
      let sequenceModeAction = action as updateProductListSequenceModeAction;
      let newState = {
        ...state,
        sequenceMode: sequenceModeAction.sequenceMode
          ? sequenceModeAction.sequenceMode
          : SEQUENCE_MODE_TYPE.VIEW,
      };
      if (sequenceModeAction.sequenceMode === SEQUENCE_MODE_TYPE.VIEW) {
        newState = {
          ...newState,
          editSequenceList: state.productSequences,
          isSequenceUpdated: true,
          pinnedProducts: {
            ...state.pinnedProducts,
            numberOfPinnedProducts:
              state.pinnedProducts.pinnedProductIds.length,
          },
        };
      }
      return newState;

    case UPDATE_PINNED_PRODUCTS.SUCCESS: {
      const pinnedProductIds = state.editSequenceList
        .map((product) => product.productId)
        .slice(0, state.pinnedProducts.numberOfPinnedProducts);
      const pinnedProducts = {
        numberOfPinnedProducts: pinnedProductIds.length,
        pinnedProductIds,
      };
      return {
        ...state,
        pinnedProducts,
      };
    }

    case UPDATE_NUMBER_OF_PINNED_PRODUCTS: {
      const updateNumberOfPinnedProductsAction =
        action as UpdateNumberOfPinnedProductsAction;
      const numberOfPinnedProducts =
        updateNumberOfPinnedProductsAction.payload.numberOfPinnedProducts;
      const pinnedProducts = {
        ...state.pinnedProducts,
        numberOfPinnedProducts,
      };
      return {
        ...state,
        pinnedProducts,
      };
    }

    case SET_PINNED_PRODUCTS_MODE: {
      const setPinnedProductsModeActionAction =
        action as SetPinnedProductsModeAction;
      const isPinnedProductsMode =
        setPinnedProductsModeActionAction.isPinnedProductsMode;
      return {
        ...state,
        isPinnedProductsMode,
      };
    }

    case SET_SORTING_RULE: {
      const setSortingRuleAction = action as SetSortingRuleAction;
      const sortingRule = setSortingRuleAction.rule;
      return {
        ...state,
        sortingRule,
      };
    }

    case RESET_PRODUCT_SEQUENCE: {
      return {
        ...state,
        isSequenceUpdated: false,
        isProductSequenceUpdated: false,
      };
    }

    case RESET_PRODUCT_LIST: {
      const pinnedProducts = state.pinnedProducts;
      const watchedProductList = [...state.watchedProductList];
      // Preserve savingCategoryIds and currentUserInitiatedSaves since saves are account-wide
      // and should persist across store/catalog changes (like SyncCategoriesNotificationPanel)
      const savingCategoryIds = state.savingCategoryIds;
      const currentUserInitiatedSaves = state.currentUserInitiatedSaves;
      return {
        ...initialState,
        pinnedProducts,
        watchedProductList,
        savingCategoryIds,
        currentUserInitiatedSaves,
        progressCache: {}, // Reset progress cache when product list is reset
      };
    }
    case FETCH_SORTING_LIST.SUCCESS: {
      const sortingRulesListAction =
        action as LoadSortingRulesListResponseAction;
      const sortingRulesList = sortingRulesListAction.payload.results;
      return {
        ...state,
        sortingRulesList,
        isSortingRulesListLoaded: true,
      };
    }
    case UPDATE_PRODUCT_SEQUENCE: {
      return {
        ...state,
        isUpdateProductSequenceError: false,
      };
    }
    case UPDATE_PRODUCT_SEQUENCE_LIST_SYNC.REQUEST: {
      const categoryId = action.payload?.categoryId;
      const isFromProductDeleteOperation = action.payload?.isFromProductDeleteOperation ?? false;
      const shouldTrack = !isFromProductDeleteOperation && categoryId;
      return {
        ...state,
        isUpdateProductSequenceError: false,
        isSequenceSaving: shouldTrack,
        savingCategoryIds: shouldTrack && !state.savingCategoryIds.includes(categoryId)
          ? [...state.savingCategoryIds, categoryId]
          : state.savingCategoryIds,
      };
    }
    case UPDATE_PRODUCT_SEQUENCE_LIST_SYNC.SUCCESS: {
      let stateProductIds: string[] = [];
      if (state.updatedStateProductIds.length > 0) {
        //Displaying updated products when we do the refresh all after saving the product sorting/sequence
        stateProductIds = [...Object.values(state.updatedStateProductIds)];
      } else {
        stateProductIds = [...Object.values(state.productIds)];
      }
      const categoryId = action.payload?.categoryId;
      const newSavingCategoryIds = categoryId
        ? state.savingCategoryIds.filter((id) => id !== categoryId)
        : state.savingCategoryIds;
      return {
        ...state,
        isUpdateProductSequenceError: false,
        isSequenceSaving: newSavingCategoryIds.length > 0,
        savingCategoryIds: newSavingCategoryIds,
        productIds: stateProductIds,
        sequenceMode: 1,
        originalEditSequenceList: state.editSequenceList,
        originalProductSequences: state.productSequences,
        originalPositionedProductIds: state.updatedPositionedProductIds,
        isProductSequenceUpdated: false,
      };
    }
    case UPDATE_PRODUCT_SEQUENCE_LIST_SYNC.FAILURE: {
      const categoryId = action.payload?.categoryId || (action as any).meta?.categoryId;
      const newSavingCategoryIds = categoryId
        ? state.savingCategoryIds.filter((id) => id !== categoryId)
        : state.savingCategoryIds;
      return {
        ...state,
        isUpdateProductSequenceError: true,
        isSequenceSaving: newSavingCategoryIds.length > 0,
        savingCategoryIds: newSavingCategoryIds,
      };
    }
    case UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC.REQUEST: {
      const categoryId = action.payload?.categoryId;
      return {
        ...state,
        isUpdateProductSequenceError: false,
        isSequenceLoading: false,
        isBoostBurySequenceRequested: true,
        savingCategoryIds: categoryId && !state.savingCategoryIds.includes(categoryId)
          ? [...state.savingCategoryIds, categoryId]
          : state.savingCategoryIds,
        currentUserInitiatedSaves: categoryId && !state.currentUserInitiatedSaves.includes(categoryId)
          ? [...state.currentUserInitiatedSaves, categoryId]
          : state.currentUserInitiatedSaves,
      };
    }
    case UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC.SUCCESS: {
      let stateProductIds: string[] = [];
      if (state.updatedStateProductIds.length > 0) {
        //Displaying updated products when we do the refresh all after saving the product sorting/sequence
        stateProductIds = [...Object.values(state.updatedStateProductIds)];
      } else {
        stateProductIds = [...Object.values(state.productIds)];
      }
      const categoryId = action.payload?.categoryId;
      const requestId = action.payload.requestId;
      
      // Store requestId -> {categoryId, payload} mapping so we can match it when WebSocket event arrives and retry if needed
      const savePayload = (action as any).meta?.savePayload;
      const pendingCategorySaveRequestIds = {
        ...(state.pendingCategorySaveRequestIds || {}),
        [requestId]: { categoryId, payload: savePayload },
      };
      
      return {
        ...state,
        requestId: requestId,
        isUpdateFunctionInvoked: true,
        productIds: stateProductIds,
        isProductSequenceUpdated: false,
        // Keep categoryId in savingCategoryIds during polling phase
        savingCategoryIds: categoryId && !state.savingCategoryIds.includes(categoryId)
          ? [...state.savingCategoryIds, categoryId]
          : state.savingCategoryIds,
        pendingCategorySaveRequestIds,
      };
    }
    case UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC.FAILURE: {
      const categoryId = action.payload?.categoryId || (action as any).meta?.categoryId;
      const newSavingCategoryIds = categoryId
        ? state.savingCategoryIds.filter((id) => id !== categoryId)
        : state.savingCategoryIds;
      return {
        ...state,
        isUpdateProductSequenceError: true,
        isUpdateFunctionInvoked: newSavingCategoryIds.length > 0,
        isBoostBurySequenceRequested: newSavingCategoryIds.length > 0,
        savingCategoryIds: newSavingCategoryIds,
        currentUserInitiatedSaves: categoryId
          ? state.currentUserInitiatedSaves.filter((id) => id !== categoryId)
          : state.currentUserInitiatedSaves,
      };
    }
    case GET_PRODUCT_SEQUENCE_LIST.SUCCESS: {
      const productSequenceRes = action.payload;
      return {
        ...state,
        isSequenceLoading: false,
        productSequenceList: productSequenceRes,
        isSquenceUpdateRequest: false,
      };
    }
    case GET_PRODUCT_SEQUENCE_LIST.DONE: {
      const categoryId = action.payload?.categoryId;
      const newSavingCategoryIds = categoryId
        ? state.savingCategoryIds.filter((id) => id !== categoryId)
        : state.savingCategoryIds;
      return {
        ...state,
        isSequenceLoading: false,
        isSquenceUpdateRequest: true,
        isUpdateFunctionInvoked: newSavingCategoryIds.length > 0,
        savingCategoryIds: newSavingCategoryIds,
        sequenceMode: 1,
        originalEditSequenceList: state.editSequenceList,
        originalProductSequences: state.productSequences,
        originalPositionedProductIds: state.updatedPositionedProductIds,
      };
    }
    case GET_PRODUCT_SEQUENCE_LIST.FAILURE: {
      const categoryId = action.payload?.categoryId;
      const newSavingCategoryIds = categoryId
        ? state.savingCategoryIds.filter((id) => id !== categoryId)
        : state.savingCategoryIds;
      return {
        ...state,
        isUpdateFunctionInvoked: newSavingCategoryIds.length > 0,
        savingCategoryIds: newSavingCategoryIds,
      };
    }
    case FETCH_PRODUCT_IDS.REQUEST: {
      const payload = action.payload;
      const Ids = payload.productIds ? state.productIds : [];
      return {
        ...state,
        productIds: payload.next ? state.productIds : Ids,
        productSequences: [],
        editSequenceList: [],
        isFetchingProductIds: payload.productIds ? false : true,
        isFetchingCategoryProductIds: payload.productIds ? false : true,
        isProductIdsFetched: false,
        isRefreshingAllProducts: payload.isRefreshingAllProducts ? true : false,
        total: undefined,
        progressCache: payload.next ? state.progressCache : {}, // Reset progress cache when starting fresh (not pagination)
      };
    }
    case FETCH_PRODUCT_IDS.SUCCESS: {
      const payload: ProductIdsData = action.payload;
      const productIdData = payload.productIds;
      const isCategoryChanged = state.isNewCategory;
      const pIds = isCategoryChanged || state.productIds.length === 0
        ? productIdData
        : state.productIds.concat(productIdData);
      // If category changed, start fresh with new sequences, otherwise merge
      const updatedProductSequences = isCategoryChanged
        ? productIdData?.map((productId) => ({ productId })) || []
        : [
            ...state.productSequences,
            ...pIds
              ?.filter(
                (productId) =>
                  !state.productSequences.some((p) => p.productId === productId),
              )
              ?.map((productId) => ({ productId })),
          ];
      const updatedEditSequenceList = isCategoryChanged
        ? productIdData?.map((productId) => ({ productId })) || []
        : [
            ...state.editSequenceList,
            ...pIds
              ?.filter(
                (productId) =>
                  !state.editSequenceList.some((p) => p.productId === productId),
              )
              ?.map((productId) => ({ productId })),
          ];
      return {
        ...state,
        productIds: pIds,
        productSequences: updatedProductSequences,
        editSequenceList: updatedEditSequenceList,
        updatedStateProductIds: pIds,
        isProductIdsFetched: true,
        isFetchingProductIds: false,
        isFetchingCategoryProductIds: payload.next ? true : false,
        isRefreshingAllProducts: false,
        productIdsData: payload,
        total: payload.total,
        isFetched: !payload.next && pIds.length === 0 ? true : state.isFetched,
        originalEditSequenceList: updatedEditSequenceList,
        originalProductSequences: updatedProductSequences,
        isNewCategory: false,
      };
    }
    case FETCH_PRODUCT_IDS.FAILURE: {
      return {
        ...state,
        isProductIdsFetched: false,
        isFetchingProductIds: false,
        isFetchingCategoryProductIds: false,
        isRefreshingAllProducts: false,
      };
    }
    case ADD_PRODUCT_IN_CATEGORY.REQUEST: {
      const productId = action.payload.productId;
      let updatedProductIdsList = [
        ...(state.addingRemovingProductIdsList as string[]),
      ];
      updatedProductIdsList?.push(productId);
      return {
        ...state,
        addingRemovingProductIdsList: updatedProductIdsList,
      };
    }
    case ADD_PRODUCT_IN_CATEGORY.FAILURE:
    case ADD_PRODUCT_IN_CATEGORY.SUCCESS: {
      const productId = action.payload.productId;
      let updatedProductIdsList = [
        ...(state.addingRemovingProductIdsList as string[]),
      ];
      updatedProductIdsList = updatedProductIdsList?.filter(
        (id) => id !== productId,
      );
      let updatedProductIds = [...state.productIds];
      updatedProductIds.push(productId);
      return {
        ...state,
        addingRemovingProductIdsList: updatedProductIdsList,
        productIds: updatedProductIds,
        updatedStateProductIds: updatedProductIds,
      };
    }
    case REMOVE_PRODUCT_IN_CATEGORY.REQUEST: {
      const productId = action.payload.productId;
      const updatedProductIdsList = [
        ...(state.addingRemovingProductIdsList as string[]),
      ];
      updatedProductIdsList?.push(productId);
      return {
        ...state,
        addingRemovingProductIdsList: updatedProductIdsList,
      };
    }
    case REMOVE_PRODUCT_IN_CATEGORY.SUCCESS: {
      const productIdToBeRemoved = action.payload.productId;
      const removeFromCategory = action.payload.isFromCategory;

      const isPublishedAndIsCategory = action.payload.isPublished;

      const productSequencesData = [...state.productSequences];
      const updatedProductList = productSequencesData.filter(
        (product) => product.productId !== productIdToBeRemoved,
      );
      let updatedProductIdsList = [
        ...(state.addingRemovingProductIdsList as string[]),
      ];
      updatedProductIdsList = updatedProductIdsList?.filter(
        (id) => id !== productIdToBeRemoved,
      );

      return {
        ...state,
        productSequences: updatedProductList,
        editSequenceList: updatedProductList,
        productIds: isPublishedAndIsCategory
          ? state.productIds.filter((id) => id !== productIdToBeRemoved)
          : !removeFromCategory
            ? state.productIds
            : state.productIds.filter((id) => id !== productIdToBeRemoved),
        addingRemovingProductIdsList: updatedProductIdsList,
        originalEditSequenceList: updatedProductList,
        originalProductSequences: updatedProductList,
        updatedPositionedProductIds: state.updatedPositionedProductIds?.filter(
          (id) => id !== productIdToBeRemoved,
        ),
        originalPositionedProductIds:
          state.originalPositionedProductIds?.filter(
            (id) => id !== productIdToBeRemoved,
          ),
      };
    }
    case REMOVE_PRODUCT_IN_CATEGORY.FAILURE: {
      const productIdToBeRemoved = action.payload.productId;
      let updatedProductIdsList = [
        ...(state.addingRemovingProductIdsList as string[]),
      ];
      updatedProductIdsList?.filter((id) => id !== productIdToBeRemoved);
      return {
        ...state,
        addingRemovingProductIdsList: updatedProductIdsList,
      };
    }
    case FETCH_PRODUCT.REQUEST: {
      const productData = action?.payload;
      return {
        ...state,
        isProductAddedToCategoryFromClipBoard:
          !!productData.isProductAddedFromClipBoard,
      };
    }
    case FETCH_PRODUCT.SUCCESS: {
      const productData = action?.payload;
      const updatedProductSequencesData = [...state.productSequences];
      const updatedProductIds =
        state.updatedStateProductIds.length > 0
          ? [...state.updatedStateProductIds]
          : [...state.productIds];
      if (productData && productData.productId) {
        //Check if the product is not removedProduct.
        if (!productData.isProductRemoved) {
          const existsInSequences = updatedProductSequencesData.some(
            (item) => item.productId === productData.productId,
          );
          //handle Add product case if not exist in sequence
          if (!existsInSequences) {
            updatedProductSequencesData.push({
              sequence: productData?.cachedProduct?.sequence,
              productId: productData?.productId,
            });
          }
          if (
            state.isProductAddedToCategoryFromClipBoard &&
            !updatedProductIds.includes(productData.productId)
          ) {
            updatedProductIds.push(productData.productId);
            updatedProductSequencesData.sort(
              (a, b) => (a.sequence ?? 0) - (b.sequence ?? 0),
            );
            const sequenceByProductId = new Map(
              updatedProductSequencesData.map((s) => [
                s.productId,
                s.sequence ?? 0,
              ]),
            );
            updatedProductIds.sort(
              (a, b) =>
                (sequenceByProductId.get(a) ?? 0) -
                (sequenceByProductId.get(b) ?? 0),
            );
          }
        } else {
          //Remove product from sequence and updatedProductIds
          const indexToRemove = updatedProductSequencesData.findIndex(
            (item) => item.productId === productData.productId,
          );
          if (indexToRemove !== -1) {
            updatedProductSequencesData.splice(indexToRemove, 1);
          }
          const idIndexToRemove = updatedProductIds.indexOf(
            productData.productId,
          );
          if (idIndexToRemove !== -1) {
            updatedProductIds.splice(idIndexToRemove, 1);
          }
        }
      }
      let updatedProductIdsData = { ...state.productIdsData };
      if (updatedProductIds.length !== state.productIdsData.total) {
        updatedProductIdsData.productIds = updatedProductIds;
        updatedProductIdsData.total = updatedProductIds.length;
      }

      return {
        ...state,
        productSequences: updatedProductSequencesData,
        editSequenceList: updatedProductSequencesData,
        productIds: updatedProductIds,
        updatedStateProductIds: updatedProductIds,
        originalEditSequenceList: updatedProductSequencesData,
        originalProductSequences: updatedProductSequencesData,
        productIdsData: updatedProductIdsData,
      };
    }
    case REVERT_PRODUCT_SEQUENCE: {
      return {
        ...state,
        editSequenceList: state.originalEditSequenceList,
        productSequences: state.originalProductSequences,
        updatedStateProductIds: state.productIds,
        sequenceMode: 1,
        isProductSequenceUpdated: false,
        updatedPositionedProductIds: state.originalPositionedProductIds,
      };
    }
    case ADD_PRODUCTS_TO_CATEGORIES.COMPLETED: {
      const orderedIds: string[] = action?.payload?.addedProducts ?? [];
      if (!orderedIds.length) {
        return state;
      }
      const orderedSet = new Set(orderedIds);
      const remainingSequences = state.productSequences.filter(
        (s) => !orderedSet.has(s.productId),
      );
      const remainingProductIds = (
        state.updatedStateProductIds.length > 0
          ? state.updatedStateProductIds
          : state.productIds
      ).filter((id) => !orderedSet.has(id));
      const baseSequence = remainingSequences.length;
      const appendedSequences = orderedIds.map((productId, idx) => ({
        productId,
        sequence: baseSequence + idx + 1,
      }));
      const finalSequences = [...remainingSequences, ...appendedSequences];
      const finalProductIds = [...remainingProductIds, ...orderedIds];
      const updatedProductIdsData = { ...state.productIdsData };
      if (finalProductIds.length !== state.productIdsData.total) {
        updatedProductIdsData.productIds = finalProductIds;
        updatedProductIdsData.total = finalProductIds.length;
      }
      return {
        ...state,
        productSequences: finalSequences,
        editSequenceList: finalSequences,
        productIds: finalProductIds,
        updatedStateProductIds: finalProductIds,
        originalEditSequenceList: finalSequences,
        originalProductSequences: finalSequences,
        productIdsData: updatedProductIdsData,
      };
    }
    case FETCH_WATCHED_PRODUCT_LIST.SUCCESS: {
      const productListResponse = action.payload as WatchedProductListResponse;
      return {
        ...state,
        watchedProductList: productListResponse.results,
      };
    }
    case ADD_PRODUCT_TO_WATCH_LIST.SUCCESS: {
      const addProductToWatchListResponse =
        action.payload as addRemoveProductInWatchListPayload;
      const watchedProducts = [
        ...state.watchedProductList,
        {
          productId: addProductToWatchListResponse.productId,
          storeId: addProductToWatchListResponse.storeId,
          watchers: [addProductToWatchListResponse.watcher],
        },
      ];
      return {
        ...state,
        watchedProductList: watchedProducts,
      };
    }
    case REMOVE_PRODUCT_FROM_WATCH_LIST.SUCCESS: {
      const removeProductFromWatchListResponse =
        action.payload as addRemoveProductInWatchListPayload;
      const watchedProducts = [...state.watchedProductList]?.filter(
        (watchedProduct) =>
          watchedProduct.productId !==
          removeProductFromWatchListResponse.productId,
      );
      return {
        ...state,
        watchedProductList: watchedProducts,
      };
    }
    case RESET_SEQUENCE_REQUESTED_BY_BOOST_BURY: {
      return {
        ...state,
        isBoostBurySequenceRequested: false,
      };
    }
    case FETCH_LOCKS_FOR_CATEGORY.SUCCESS: {
      const locksInCategoryResponse = action.payload as LocksInCategoryResponse;
      const locksInCategory =
        state.locksInCategory.length > 0
          ? locksInCategoryResponse.results?.filter(
              (newLock) =>
                !state.locksInCategory.some(
                  (existingLock) =>
                    existingLock.productId === newLock.productId &&
                    existingLock.catalogId === newLock.catalogId &&
                    existingLock.categoryId === newLock.categoryId,
                ),
            )
          : locksInCategoryResponse.results;
      return {
        ...state,
        locksInCategory: [...state.locksInCategory, ...locksInCategory],
      };
    }
    case LOCK_PRODUCT_COMPLETED: {
      const lockProductResponse = action.payload as LocksInCategory;
      const existingLockIndex = state.locksInCategory.findIndex(
        (lock) =>
          lock.catalogId === lockProductResponse.catalogId &&
          lock.categoryId === lockProductResponse.categoryId &&
          lock.position === lockProductResponse.position,
      );

      let updatedLocks: LocksInCategory[];
      if (existingLockIndex !== -1) {
        // Update existing lock
        updatedLocks = [...state.locksInCategory];
        updatedLocks[existingLockIndex] = lockProductResponse;
      } else {
        // Insert new lock
        updatedLocks = [...state.locksInCategory, lockProductResponse];
      }

      const updatedLocksRemoveInCategory =
        state.locksRemoveInCategory?.filter(
          (lock) =>
            !updatedLocks?.some(
              (newLock) => newLock.productId === lock.productId,
            ),
        ) ?? [];
      return {
        ...state,
        locksInCategory: updatedLocks,
        locksRemoveInCategory: updatedLocksRemoveInCategory,
        savedUnlockedProductsInCategory: [
          ...state.savedUnlockedProductsInCategory?.filter(
            (product) => product.productId !== lockProductResponse.productId,
          ),
        ],
      };
    }
    case UNLOCK_PRODUCT_COMPLETED: {
      const unlockProductResponse =
        action.payload as UnLockProductResponsePayload;
      const locksInCategory = state.locksInCategory?.filter(
        (lock) =>
          !(
            lock.catalogId === unlockProductResponse.catalogId &&
            lock.categoryId === unlockProductResponse.categoryId &&
            lock.position === unlockProductResponse.position
          ),
      );
      // Check if unlock response already exists in locksRemoveInCategory
      const isDuplicate = state.locksRemoveInCategory?.some(
        (lock) =>
          lock.catalogId === unlockProductResponse.catalogId &&
          lock.categoryId === unlockProductResponse.categoryId &&
          lock.position === unlockProductResponse.position,
      );

      const locksRemoveInCategory = isDuplicate
        ? state.locksRemoveInCategory
        : [...state.locksRemoveInCategory, unlockProductResponse];

      return {
        ...state,
        locksInCategory: locksInCategory,
        locksRemoveInCategory: locksRemoveInCategory,
        savedLockedProductsInCategory: [
          ...state.savedLockedProductsInCategory?.filter(
            (product) => product.productId !== unlockProductResponse.productId,
          ),
        ],
      };
    }
    case RESET_LOCKS_IN_CATEGORY: {
      return {
        ...state,
        locksInCategory: [],
        locksRemoveInCategory: [],
        savedLockedProductsInCategory: [],
        savedUnlockedProductsInCategory: [],
      };
    }
    case SET_LOCKED_UNLOCKED_PRODUCTS: {
      const lockedUnlockedProducts = action.payload;

      // Check if product exists in either list before filtering
      const wasExistingInLockedListBefore =
        state.savedLockedProductsInCategory?.some(
          (product) =>
            product.productId === lockedUnlockedProducts.productId &&
            product.categoryId === lockedUnlockedProducts.categoryId,
        );
      const wasLockedInCategory = state.locksInCategory.some(
        (lock) =>
          lock.productId === lockedUnlockedProducts.productId &&
          lock.categoryId === lockedUnlockedProducts.categoryId,
      );

      const wasExistingInUnlockedListBefore =
        state.savedUnlockedProductsInCategory?.some(
          (product) =>
            product.productId === lockedUnlockedProducts.productId &&
            product.categoryId === lockedUnlockedProducts.categoryId,
        );
      const wasUnlockedInCategory = state.locksRemoveInCategory?.some(
        (lock) =>
          lock.productId === lockedUnlockedProducts.productId &&
          lock.categoryId === lockedUnlockedProducts.categoryId,
      );

      // Filter out the product from both lists
      const filteredLockedProducts =
        state.savedLockedProductsInCategory?.filter(
          (product) =>
            !(
              product.productId === lockedUnlockedProducts.productId &&
              product.categoryId === lockedUnlockedProducts.categoryId
            ),
        ) ?? [];
      const filteredUnlockedProducts =
        state.savedUnlockedProductsInCategory?.filter(
          (product) =>
            !(
              product.productId === lockedUnlockedProducts.productId &&
              product.categoryId === lockedUnlockedProducts.categoryId
            ),
        ) ?? [];

      // Only add to locked list if it wasn't just removed from unlocked list or was unlocked in database
      if (
        lockedUnlockedProducts.isLocked &&
        (!wasExistingInUnlockedListBefore || wasUnlockedInCategory)
      ) {
        filteredLockedProducts.push(lockedUnlockedProducts);
      }
      // Only add to unlocked list if it wasn't just removed from locked list or was locked in database
      else if (
        !lockedUnlockedProducts.isLocked &&
        (!wasExistingInLockedListBefore || wasLockedInCategory)
      ) {
        filteredUnlockedProducts.push(lockedUnlockedProducts);
      }
      let updatedPinnedProducts: string[] = [...state.storedPinnedProductIds];
      if (filteredUnlockedProducts.length > 0) {
        // Get all pinned products (both from DB and stored)
        const allPinnedProducts = [
          ...new Set([
            ...state.pinnedProductIds,
            ...state.storedPinnedProductIds,
          ]),
        ]?.filter((id) => !state.storedUnpinnedProductIds.includes(id));

        // Find products that need to be pinned
        const productsNeedingPinning = filteredUnlockedProducts.filter(
          (unlockedProduct) => {
            const unlockedIndex = state.productSequences.findIndex(
              (seq) => seq.productId === unlockedProduct.productId,
            );

            if (unlockedIndex === -1) return false;

            // Check if any pinned products exist after this position
            return state.productSequences
              .slice(unlockedIndex + 1)
              .some((product) => allPinnedProducts.includes(product.productId));
          },
        );

        // Update pinned products list
        updatedPinnedProducts = [
          ...new Set([
            ...state.storedPinnedProductIds,
            ...state.pinnedProductIds?.filter(
              (id) => !state.storedUnpinnedProductIds.includes(id),
            ),
            ...productsNeedingPinning?.map((product) => product.productId),
          ]),
        ];
      } else {
        updatedPinnedProducts = [...state.originalStoredPinnedProductIds];
      }

      const lockedPinnedProductIds = filteredLockedProducts
        ?.filter(
          (product) =>
            updatedPinnedProducts.includes(product.productId) ||
            state.pinnedProductIds.includes(product.productId),
        )
        ?.map((product) => product.productId);

      if (lockedPinnedProductIds.length > 0) {
        updatedPinnedProducts = [
          ...new Set([...updatedPinnedProducts, ...state.pinnedProductIds]),
        ]?.filter((productId) => !lockedPinnedProductIds.includes(productId));
      }

      return {
        ...state,
        savedLockedProductsInCategory: filteredLockedProducts,
        savedUnlockedProductsInCategory: filteredUnlockedProducts,
        storedPinnedProductIds: updatedPinnedProducts,
        sequenceMode:
          filteredLockedProducts.length ||
          filteredUnlockedProducts.length > 0 ||
          updatedPinnedProducts?.filter(
            (id) => !state.pinnedProductIds?.includes(id),
          )?.length > 0 ||
          state.storedUnpinnedProductIds.length > 0
            ? SEQUENCE_MODE_TYPE.EDIT
            : SEQUENCE_MODE_TYPE.VIEW,
      };
    }
    case RESET_SAVED_LOCKED_UNLOCKED_PRODUCTS: {
      return {
        ...state,
        savedLockedProductsInCategory: [],
        savedUnlockedProductsInCategory: [],
        sequenceMode: SEQUENCE_MODE_TYPE.VIEW,
      };
    }
    case GET_CONTENT_SLOTS.SUCCESS: {
      const contentSlotsResponse = action.payload as ContentSlotsResponse;
      const contentSlots = contentSlotsResponse.slots?.map((slot) => ({
        ...slot,
        type: "slot",
      }));
      return {
        ...state,
        contentSlots: contentSlots,
      };
    }
    case RESET_CONTENT_SLOTS: {
      return {
        ...state,
        contentSlots: [],
      };
    }
    case UPDATE_CONTENT_SLOT_STATE: {
      const updateContentSlotStateResponse =
        action.payload as updateContentSlotStateResponse;
      const existingContentSlot = state.contentSlots?.find(
        (slot) => slot.slotId === updateContentSlotStateResponse.slotId,
      );
      let newContentSlot: ContentSlot;
      if (existingContentSlot) {
        newContentSlot = {
          ...existingContentSlot,
          position: updateContentSlotStateResponse.position,
          type: "slot",
        };
      } else {
        newContentSlot = {
          slotId: updateContentSlotStateResponse.slotId,
          position: updateContentSlotStateResponse.position,
          type: "slot",
        };
      }

      // Filter out any existing slots with the same slotId before adding the new one
      const filteredContentSlots = state.contentSlots?.filter(
        (slot) => slot.slotId !== updateContentSlotStateResponse.slotId,
      );

      return {
        ...state,
        contentSlots: [...filteredContentSlots, newContentSlot],
      };
    }
    case DELETE_CONTENT_SLOT_COMPLETED: {
      const deleteContentSlotResponse =
        action.payload as deleteContentSlotPayload;
      const filteredContentSlots = state.contentSlots?.filter(
        (slot) => slot.slotId !== deleteContentSlotResponse.slotId,
      );
      return {
        ...state,
        contentSlots: filteredContentSlots,
      };
    }
    case SET_PINNED_UNPINNED_PRODUCTS: {
      const { productId, isPinned, catalogId, categoryId } = action.payload;
      const existingStoredPinnedProducts = state.storedPinnedProductIds;
      const pinnedProductsFromDB = [...state.pinnedProductIds];
      let unpinnedProducts = [...state.storedUnpinnedProductIds];

      if (!isPinned) {
        unpinnedProducts = [productId, ...unpinnedProducts];
      } else {
        unpinnedProducts = unpinnedProducts.filter((id) => id !== productId);
      }

      const combinedPinnedProducts = [
        ...new Set([...pinnedProductsFromDB, ...existingStoredPinnedProducts]),
      ];

      const filteredPinnedProducts = combinedPinnedProducts.filter(
        (id) =>
          !state.savedLockedProductsInCategory.some(
            (product) => product.productId === id,
          ),
      );

      const updatedPinnedProducts = isPinned
        ? [...new Set([...filteredPinnedProducts, productId])]?.filter(
            (id) => !unpinnedProducts.includes(id),
          )
        : filteredPinnedProducts.filter((id) => !unpinnedProducts.includes(id));

      return applyPinnedUnpinnedProductsSequenceUpdate(
        state,
        catalogId,
        categoryId,
        unpinnedProducts,
        updatedPinnedProducts,
        !isPinned ? new Set([productId]) : new Set<string>(),
        [productId],
      );
    }
    case BULK_SET_PINNED_UNPINNED_PRODUCTS: {
      const { toUnpin, toPin, catalogId, categoryId } =
        action.payload as bulkPinnedUnPinnedProductsPayload;
      if (toUnpin.length === 0 && toPin.length === 0) {
        return state;
      }
      let u = [...state.storedUnpinnedProductIds];
      let storedPinned = [...state.storedPinnedProductIds];
      const dbPinned = [...state.pinnedProductIds];
      const lockedIds = new Set(
        state.savedLockedProductsInCategory.map((p) => p.productId),
      );
      const isLockedFilter = (id: string) => !lockedIds.has(id);
      let uSet = new Set(u);

      for (const productId of toUnpin) {
        u = [productId, ...u];
        uSet.add(productId);
        const combined = [...new Set([...dbPinned, ...storedPinned])];
        const filtered = combined.filter(isLockedFilter);
        storedPinned = filtered.filter((id) => !uSet.has(id));
      }
      for (const productId of toPin) {
        u = u.filter((id) => id !== productId);
        uSet.delete(productId);
        const combined = [...new Set([...dbPinned, ...storedPinned])];
        const filtered = combined.filter(isLockedFilter);
        storedPinned = [...new Set([...filtered, productId])].filter(
          (id) => !uSet.has(id),
        );
      }

      return applyPinnedUnpinnedProductsSequenceUpdate(
        state,
        catalogId,
        categoryId,
        u,
        storedPinned,
        new Set(toUnpin),
        toPin,
      );
    }
    case SET_PINNED_PRODUCTS.SUCCESS: {
      const setPinnedProductsResponse = action.payload;
      return {
        ...state,
        pinnedProductIds: setPinnedProductsResponse.pinnedProductIds,
        storedUnpinnedProductIds: [],
        storedPinnedProductIds: [],
        originalStoredPinnedProductIds: [],
      };
    }
    case GET_PINNED_PRODUCTS.SUCCESS: {
      const getPinnedProductsResponse =
        action.payload as getPinnedProductsResponse;
      return {
        ...state,
        pinnedProductIds:
          getPinnedProductsResponse.results[0]?.pinnedProductIds ?? [],
      };
    }
    case RESET_STORED_PINNED_UNPINNED_PRODUCT_IDS: {
      return {
        ...state,
        storedPinnedProductIds: [],
        storedUnpinnedProductIds: [],
        originalStoredPinnedProductIds: [],
      };
    }
    case RESET_PINNED_UNPINNED_PRODUCTS: {
      return {
        ...state,
        pinnedProductIds: [],
        storedPinnedProductIds: [],
        storedUnpinnedProductIds: [],
        originalStoredPinnedProductIds: [],
      };
    }
    case SET_CONTENT_SLOT_LOADING: {
      return {
        ...state,
        isContentSlotLoading: true,
      };
    }
    case RESET_CONTENT_SLOT_LOADING: {
      return {
        ...state,
        isContentSlotLoading: false,
      };
    }
    case SET_SELECTED_ITEMS: {
      // If payload is empty, set selectedItems to empty array
      if (!action.payload.items || action.payload.items.length === 0) {
        return {
          ...state,
          selectedItems: [],
        };
      }
      if (action.payload.isDraggedItems) {
        return {
          ...state,
          selectedItems: action.payload.items,
        };
      }

      // If the new items are already in the current selection, maintain their order
      const currentSelectedItems = [...state.selectedItems];
      const newItems = action.payload.items;

      // Create a map of existing items for quick lookup
      const existingItemsMap = new Map(
        currentSelectedItems.map((item) => [item.productId, item]),
      );

      // Create a map of new items for quick lookup
      const newItemsMap = new Map(
        newItems.map((item) => [item.productId, item]),
      );

      // Keep existing items in their current order
      const orderedItems = currentSelectedItems.filter((item) =>
        newItemsMap.has(item.productId),
      );

      // Add any new items that weren't in the current selection
      const newItemsToAdd = newItems.filter(
        (item) => !existingItemsMap.has(item.productId),
      );

      return {
        ...state,
        selectedItems: [...orderedItems, ...newItemsToAdd],
      };
    }
    case LOAD_INITIAL_PRODUCTS_DETAILS.REQUEST: {
      const payload = action.payload;
      const Ids = payload.productIds ? state.productIds : [];
      return {
        ...state,
        productIds: payload.next ? state.productIds : Ids,
        productSequences: [],
        editSequenceList: [],
        isFetchingProductIds: payload.productIds ? false : true,
        isProductIdsFetched: false,
        isRefreshingAllProducts: payload.isRefreshingAllProducts ? true : false,
        total: undefined,
        progressCache: payload.next ? state.progressCache : {}, // Reset progress cache when starting fresh (not pagination)
        isFetchingCategoryProductIds: payload.productIds ? false : true,
      };
    }
    case LOAD_INITIAL_PRODUCTS_DETAILS.SUCCESS: {
      const payload: ProductsData = action.payload;
      const productIdData =
        payload.results?.map((p) => p.product.productId) ?? [];
      const isCategoryChanged = state.isNewCategory;
      // If category changed, replace productIds instead of concatenating
      const pIds = isCategoryChanged || state.productIds.length === 0
        ? productIdData
        : state.productIds.concat(productIdData);
      // If category changed, start fresh with new sequences, otherwise merge
      const updatedProductSequences = isCategoryChanged
        ? productIdData?.map((productId) => ({
            productId,
            position: payload.results?.find(
              (p) => p.product.productId === productId,
            )?.sequence,
          })) || []
        : [
            ...state.productSequences,
            ...pIds
              ?.filter(
                (productId) =>
                  !state.productSequences.some((p) => p.productId === productId),
              )
              ?.map((productId) => ({
                productId,
                position: payload.results?.find(
                  (p) => p.product.productId === productId,
                )?.sequence,
              })),
          ];
      const updatedEditSequenceList = isCategoryChanged
        ? productIdData?.map((productId) => ({
            productId,
            position: payload.results?.find(
              (p) => p.product.productId === productId,
            )?.sequence,
          })) || []
        : [
            ...state.editSequenceList,
            ...pIds
              ?.filter(
                (productId) =>
                  !state.editSequenceList.some((p) => p.productId === productId),
              )
              ?.map((productId) => ({
                productId,
                position: payload.results?.find(
                  (p) => p.product.productId === productId,
                )?.sequence,
              })),
          ];
      const positionedProductIds =
        payload.results
          ?.filter((result) => result.sequence !== undefined)
          ?.map((p) => p.product.productId) ?? [];
      const updatedPositionedProductIds = isCategoryChanged
        ? positionedProductIds
        : [
            ...state.updatedPositionedProductIds,
            ...positionedProductIds,
          ];
      return {
        ...state,
        productIds: pIds,
        productSequences: updatedProductSequences,
        editSequenceList: updatedEditSequenceList,
        updatedStateProductIds: pIds,
        isProductIdsFetched: true,
        isFetchingProductIds: false,
        isRefreshingAllProducts: false,
        productIdsData: {
          productIds: pIds,
          categoryId: state.categoryId ?? "",
          count: payload.count,
          total: pIds.length,
          next: payload.next,
        },
        total: payload.total,
        isFetched: !payload.next && pIds.length === 0 ? true : state.isFetched,
        isFetchingCategoryProductIds: payload.next ? true : false,
        originalEditSequenceList: updatedEditSequenceList,
        originalProductSequences: updatedProductSequences,
        updatedPositionedProductIds,
        originalPositionedProductIds: updatedPositionedProductIds,
        isNewCategory: false,
      };
    }
    case LOAD_INITIAL_PRODUCTS_DETAILS.FAILURE: {
      return {
        ...state,
        isProductIdsFetched: false,
        isFetchingProductIds: false,
        isRefreshingAllProducts: false,
        isFetchingCategoryProductIds: false,
      };
    }
    case SET_CURRENT_PAGE: {
      return {
        ...state,
        currentPage: action.payload,
      };
    }
    case SET_PENDING_SCROLL_TARGET: {
      return {
        ...state,
        pendingScrollTarget: action.payload,
      };
    }
    case CLEAR_PENDING_SCROLL_TARGET: {
      return {
        ...state,
        pendingScrollTarget: null,
      };
    }
    case UPDATE_PROGRESS_CACHE: {
      const { page, progress } = action.payload;
      const cacheKey = `${page}`;
      const currentProgress = state.progressCache[cacheKey] || 0;
      const newProgress = Math.max(currentProgress, progress);

      return {
        ...state,
        progressCache: {
          ...state.progressCache,
          [cacheKey]: newProgress,
        },
      };
    }
    case RESET_PROGRESS_CACHE: {
      return {
        ...state,
        progressCache: {},
      };
    }
    case ASSIGN_PRODUCT_POSITION: {
      const { productId } = action.payload;
      const updatedPositionedProducts = [
        ...(state.updatedPositionedProductIds ?? []),
        productId,
      ];
      const updatedProductSequences = updatePositionsToProducts(
        updatedPositionedProducts,
        state.productSequences,
      );
      const productIds = updatedProductSequences?.map(
        (product) => product.productId,
      );

      return {
        ...state,
        productSequences: updatedProductSequences,
        editSequenceList: updatedProductSequences,
        updatedPositionedProductIds: updatedPositionedProducts,
        sequenceMode: SEQUENCE_MODE_TYPE.EDIT,
        isProductSequenceUpdated: true,
        updatedStateProductIds: productIds,
      };
    }
    case RESET_POSITIONED_PRODUCT_IDS: {
      return {
        ...state,
        updatedPositionedProductIds: [],
        originalPositionedProductIds: [],
      };
    }
    case UPDATE_PRODUCT_POSITION: {
      const productPositions = action.payload;
      const updatedPositionedProductIds = [
        ...new Set([
          ...productPositions
            .filter((p) => p.position !== undefined)
            .map((p) => p.productId),
          ...state.updatedPositionedProductIds,
        ]),
      ];
      const productIds = productPositions?.map((product) => product.productId);

      return {
        ...state,
        productSequences: productPositions,
        editSequenceList: productPositions,
        updatedPositionedProductIds,
        sequenceMode: SEQUENCE_MODE_TYPE.EDIT,
        isProductSequenceUpdated: true,
        updatedStateProductIds: productIds,
      };
    }
    case REMOVE_PRODUCT_POSITION: {
      const { productId } = action.payload;
      const updatedPositionedProductIds = [
        ...state.updatedPositionedProductIds?.filter((id) => id !== productId),
      ];
      // Move the product to the end of the sequence instead of removing it
      const currentProductSequences = [...(state.productSequences ?? [])];
      const indexToMove = currentProductSequences.findIndex(
        (p) => p.productId === productId,
      );

      // If found, remove the product and push it to the end
      if (indexToMove !== -1) {
        const [removed] = currentProductSequences.splice(indexToMove, 1);
        currentProductSequences.push({ ...removed });
      }

      let updatedLocksInCategory = [
        ...new Set(
          [
            ...(state.locksInCategory ?? []),
            ...(state.savedLockedProductsInCategory ?? []),
          ]?.filter(
            (lock) =>
              !state.savedUnlockedProductsInCategory.some(
                (unlocked) =>
                  unlocked.productId === lock.productId &&
                  unlocked.categoryId === lock.categoryId,
              ),
          ),
        ),
      ];
      let updateUnlockedProductsInCategory = [
        ...(state.savedUnlockedProductsInCategory ?? []),
      ];
      let finalUpdatedPositionedProductIds = [...updatedPositionedProductIds];

      // Create a fixed-size array to represent all positions
      const productList = new Array(currentProductSequences.length).fill(null);
      const lockedPositions = new Set();

      // Helper function to add product to list
      const addProductToList = (
        product: ProductSequenceData,
        position: number,
      ) => {
        productList[position] = {
          ...product,
          sequence: position + 1,
        };
      };

      // Helper function to check if product exists in list
      const isProductInList = (productId: string) => {
        return productList.some((p) => p && p.productId === productId);
      };

      // Helper function to get next available position
      const getNextAvailablePosition = () => {
        let position = 0;
        while (
          lockedPositions.has(position) ||
          productList[position] !== null
        ) {
          position++;
        }
        return position;
      };

      // 1. First place locked products in their original positions
      updatedLocksInCategory?.forEach((lock) => {
        const lockedProduct = currentProductSequences.find(
          (p) => p.productId === lock.productId,
        );
        if (lockedProduct) {
          const position = lock.position - 1; // Convert to 0-based index
          if (position >= 0 && position < productList.length) {
            lockedPositions.add(position);
            addProductToList(lockedProduct, position);
          }
        }
      });

      // 2. Place positioned products (excluding locked ones)
      currentProductSequences.forEach((product) => {
        const isLocked = updatedLocksInCategory?.some(
          (lock) => lock.productId === product.productId,
        );
        const isPositioned = finalUpdatedPositionedProductIds.includes(
          product.productId,
        );

        if (!isLocked && isPositioned && !isProductInList(product.productId)) {
          const nextPos = getNextAvailablePosition();
          addProductToList(product, nextPos);
        }
      });

      // 3. Place remaining products
      currentProductSequences.forEach((product) => {
        const isLocked = updatedLocksInCategory?.some(
          (lock) => lock.productId === product.productId,
        );
        const isPositioned = finalUpdatedPositionedProductIds.includes(
          product.productId,
        );

        if (!isLocked && !isPositioned && !isProductInList(product.productId)) {
          const nextPos = getNextAvailablePosition();
          addProductToList(product, nextPos);
        }
      });

      // Filter out null entries and create final sequence
      const updatedProductSequences = updateProductSequencePositions(
        productList.filter(Boolean),
        finalUpdatedPositionedProductIds,
      );

      // Handle undefined products and locked products using utility function
      const { updatedSequence, updatedPositionedIds, unlockActions } =
        handleUndefinedProductsAndLocks(
          updatedProductSequences,
          finalUpdatedPositionedProductIds,
          updatedLocksInCategory,
        );

      // Update the sequences and positioned IDs
      updatedProductSequences.splice(
        0,
        updatedProductSequences.length,
        ...updatedSequence,
      );
      finalUpdatedPositionedProductIds.splice(
        0,
        finalUpdatedPositionedProductIds.length,
        ...updatedPositionedIds,
      );

      // Add unlock actions to the existing array
      updateUnlockedProductsInCategory.push(...unlockActions);

      // Recreate the final sequence with updated positions
      const finalUpdatedProductSequences = updateProductSequencePositions(
        updatedProductSequences.filter(Boolean),
        finalUpdatedPositionedProductIds,
      );

      const updatedUnpinnedProductIds = [
        ...(state.storedUnpinnedProductIds ?? []),
      ];
      if (
        state.storedPinnedProductIds.includes(productId) ||
        state.pinnedProductIds.includes(productId)
      ) {
        updatedUnpinnedProductIds.push(productId);
      }
      const updatedPinnedProductIds =
        [
          ...(state.storedPinnedProductIds ?? []),
          ...(state.pinnedProductIds ?? []),
        ]?.filter(
          (id) =>
            !(
              updatedUnpinnedProductIds.includes(id) ||
              state.savedLockedProductsInCategory.some(
                (product) => product.productId === id,
              )
            ),
        ) ?? [];
      const productIds = finalUpdatedProductSequences?.map(
        (product) => product.productId,
      );

      return {
        ...state,
        productSequences: finalUpdatedProductSequences,
        editSequenceList: finalUpdatedProductSequences,
        updatedPositionedProductIds: finalUpdatedPositionedProductIds,
        savedLockedProductsInCategory: updatedLocksInCategory,
        savedUnlockedProductsInCategory: updateUnlockedProductsInCategory,
        sequenceMode: SEQUENCE_MODE_TYPE.EDIT,
        storedPinnedProductIds: updatedPinnedProductIds,
        storedUnpinnedProductIds: updatedUnpinnedProductIds,
        isProductSequenceUpdated: true,
        updatedStateProductIds: productIds,
      };
    }
    case SET_PREVIEW_OPTIONS: {
      const { payload } = action as SetPreviewOptionsAction;

      // If preview mode is being applied and products are provided, filter without reloading
      let filteredProductSequences = state.productSequences;
      let filteredEditSequenceList = state.editSequenceList;

      if (payload.products) {
        // If all filters are off (no date, stock off, published off), restore original sequences (show all products)
        if (!payload.stock && !payload.published && !payload.date) {
          filteredProductSequences = [...state.originalProductSequences];
          filteredEditSequenceList = [...state.originalEditSequenceList];
        } else {
          const previewDate = payload.date ? new Date(payload.date) : null;

          const filteredProductIds = state.productIds.filter((productId) => {
            const product = payload.products?.[productId];
            if (!product) return false;

            // Date filter: when date is set, filter products with launchDate <= preview date
            //              when date is null, don't filter (true = show all)
            let passesDateFilter = true;
            if (previewDate && product.launchDate) {
              const productLaunchDate = new Date(product.launchDate);
              // Normalize both dates to UTC start of day for timezone-agnostic comparison
              const normalizedPreviewDate = Date.UTC(
                previewDate.getUTCFullYear(),
                previewDate.getUTCMonth(),
                previewDate.getUTCDate(),
              );
              const normalizedLaunchDate = Date.UTC(
                productLaunchDate.getUTCFullYear(),
                productLaunchDate.getUTCMonth(),
                productLaunchDate.getUTCDate(),
              );
              passesDateFilter = normalizedLaunchDate <= normalizedPreviewDate;
            }

            // Stock filter: when toggle is OFF, don't filter (true = show all)
            //              when toggle is ON, filter by stock > 0
            const passesStockFilter = payload.stock
              ? (product.stock ?? 0) > 0
              : true;

            // Published filter: when toggle is OFF, don't filter (true = show all)
            //                   when toggle is ON, filter by isPublished === true
            const passesPublishedFilter = payload.published
              ? product.isPublished === true
              : true;

            // All conditions must pass (AND logic)
            // If a filter is OFF/null, that condition is always true, so it filters by the others
            return (
              passesDateFilter && passesStockFilter && passesPublishedFilter
            );
          });

          // Filter sequences from original sequences to match filtered productIds
          filteredProductSequences = state.originalProductSequences.filter(
            (seq) => filteredProductIds.includes(seq.productId),
          );
          filteredEditSequenceList = state.originalEditSequenceList.filter(
            (seq) => filteredProductIds.includes(seq.productId),
          );
        }
      }

      return {
        ...state,
        productSequences: filteredProductSequences,
        editSequenceList: filteredEditSequenceList,
        currentPage: payload.products ? 1 : state.currentPage,
        previewOptions: payload,
      };
    }
    case SET_PREVIEW_MODE: {
      const setPreviewModeAction = action as SetPreviewModeAction;
      return {
        ...state,
        isPreviewMode: setPreviewModeAction.payload.isPreviewMode,
      };
    }
    case RESET_PREVIEW: {
      return {
        ...state,
        isPreviewMode: false,
        productSequences: state.originalProductSequences,
        editSequenceList: state.originalEditSequenceList,
        currentPage: 1,
        sequenceMode: SEQUENCE_MODE_TYPE.VIEW,
        previewOptions: {
          date: null,
          stock: false,
          published: false,
        },
        remainingProductsModal: {
          isOpen: false,
          progress: 0,
          total: 0,
          loaded: 0,
          isCancelled: false,
        },
      };
    }
    case SET_REMAINING_PRODUCTS_MODAL: {
      const modalAction = action as SetRemainingProductsModalAction;
      return {
        ...state,
        remainingProductsModal: {
          ...state.remainingProductsModal,
          ...modalAction.payload,
        },
      };
    }
    case LOAD_REMAINING_PRODUCTS.CANCEL: {
      return {
        ...state,
        remainingProductsModal: {
          ...state.remainingProductsModal,
          isCancelled: true,
        },
      };
    }
    case LOAD_REMAINING_PRODUCTS.SUCCESS:
    case LOAD_REMAINING_PRODUCTS.FAILURE: {
      return {
        ...state,
        remainingProductsModal: {
          ...state.remainingProductsModal,
          isOpen: false,
          isCancelled: false,
        },
      };
    }
    case SET_IS_NEW_CATEGORY: {
      return {
        ...state,
        isNewCategory: true,
      };
    }

    case WEBSOCKET_CATEGORY_SAVE_STARTED: {
      const categoryId = (action as WebSocketCategorySaveStartedAction).payload?.categoryId;
      if (!categoryId) return state;
      return {
        ...state,
        savingCategoryIds: !state.savingCategoryIds.includes(categoryId)
          ? [...state.savingCategoryIds, categoryId]
          : state.savingCategoryIds,
      };
    }
    case WEBSOCKET_CATEGORY_SAVE_COMPLETED: {
      const { categoryId } = (action as WebSocketCategorySaveCompletedAction).payload || {};
      if (!categoryId) return state;
      const newSavingCategoryIds = state.savingCategoryIds.filter((id) => id !== categoryId);
      
      return {
        ...state,
        isSequenceLoading: false,
        isSquenceUpdateRequest: true,
        isUpdateFunctionInvoked: newSavingCategoryIds.length > 0,
        savingCategoryIds: newSavingCategoryIds,
        currentUserInitiatedSaves: state.currentUserInitiatedSaves.filter((id) => id !== categoryId),
        sequenceMode: 1,
        originalEditSequenceList: state.editSequenceList,
        originalProductSequences: state.productSequences,
        originalPositionedProductIds: state.updatedPositionedProductIds,
      };
    }
    case WEBSOCKET_CATEGORY_SAVE_FAILED: {
      const { categoryId } = (action as WebSocketCategorySaveFailedAction).payload || {};
      if (!categoryId) return state;
      
      return {
        ...state,
        isUpdateProductSequenceError: true,
        savingCategoryIds: state.savingCategoryIds.filter((id) => id !== categoryId),
        currentUserInitiatedSaves: state.currentUserInitiatedSaves.filter((id) => id !== categoryId),
      };
    }
    case FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT.SUCCESS: {
      const allRequests = (action as FetchInProgressRequestsSnapshotSuccessAction).payload?.requests || [];
      const allCategoriesBeingSaved = allRequests
        .filter((request) => request.status === "IN_PROGRESS")
        .map((request) => request.request.params.categoryId);
      const currentUserId = getUserId();
      const currentUserName = getUserName();
      const currentUserCategoryIds = allRequests
        .filter((request) => {
          const matchesUserId = currentUserId && request.userId === currentUserId;
          const matchesUserName = currentUserName && request.userName === currentUserName;
          return (matchesUserId || matchesUserName) && request.status === "IN_PROGRESS";
        })
        .map((request) => request.request.params.categoryId);
      
      return {
        ...state,
        savingCategoryIds: allCategoriesBeingSaved,
        currentUserInitiatedSaves: currentUserCategoryIds,
      };
    }
    case CLEAR_PENDING_SAVE_REQUEST_ID: {
      const { requestId } = (action as ClearPendingSaveRequestIdAction).payload || {};
      if (!requestId) return state;
      
      // Remove this requestId from pendingCategorySaveRequestIds after saga processes it
      const pendingCategorySaveRequestIds = { ...(state.pendingCategorySaveRequestIds || {}) };
      if (pendingCategorySaveRequestIds[requestId]) {
        delete pendingCategorySaveRequestIds[requestId];
      }
      
      return {
        ...state,
        pendingCategorySaveRequestIds,
      };
    }
    default:
      return state;
  }
};
